// src/utils/attribution.js
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

/**
 * Save UTMs from the current URL.
 * sticky=false  -> last-touch (overwrite when new values exist in URL)
 * sticky=true   -> first-touch (keep existing)
 * clearMissing  -> if any UTM is present in URL, remove keys not present in URL
 */
export function saveUtmParams({ sticky = false, clearMissing = false } = {}) {
  if (typeof window === "undefined") return;

  const qs = new URLSearchParams(window.location.search);
  let sawAny = false;

  UTM_KEYS.forEach((k) => {
    const v = qs.get(k);
    if (v !== null && v !== "") {
      sawAny = true;
      if (sticky) {
        if (!localStorage.getItem(k)) localStorage.setItem(k, v);
      } else {
        localStorage.setItem(k, v); // overwrite on new visits
      }
    }
  });

  // Optional: wipe old keys that aren't in the new URL
  if (sawAny && clearMissing) {
    UTM_KEYS.forEach((k) => {
      if (qs.get(k) === null) localStorage.removeItem(k);
    });
  }
}

export function getUtmParams() {
  if (typeof window === "undefined") return {};
  const out = {};
  UTM_KEYS.forEach((k) => {
    const v = localStorage.getItem(k);
    if (v) out[k] = v;
  });
  return out;
}
